<template>
  <div class="industrial_interconnection-page">
    <!-- 百倍云工业互联网 -->
    <div class="haeder-container black">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="caseDetails-banner-container">
      <div class="case-info-container">
        <p class="case-title">工业互联</p>
        <p class="case-describe">基于百倍云全面云端能力与硬件技术能力，打通设备终端到云平台，全面赋能工业行业，打造万物互联新时代</p>
        <!-- <a href="javascript:;" class="case-see-more-btn">立即咨询</a> -->
      </div>
    </div>
    <div class="caseDetails-all-content-container">
      <div class="case-introduce-item-container platform-trait">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">传感层</p>
          <p class="introduce-item-sub-title">传感器工厂生产现场需要安装大量的传感器来感知每个工序的生产参数，PLC采集传感器并进行判断给出反馈输出PLC再和其他的仪表、电表、HMI一同 接入SCADA系统，实现数据的本地汇总。 </p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/industrial_interconnection/default_img1.png" alt="" class="default_img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container platform-trait" style="background: #f5f6f9;">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">控制层</p>
          <p class="introduce-item-sub-title">PLC采集传感器并进行判断给出反馈输出，HMI实现人机交互、逻辑计算、报警、控制，SCADA软件实现数据的本地监控、汇总、计算、分析及时相应设备数据请求和控制设备的行为， 有效解决工业数据调度的一致性与完整性问题。 接入SCADA系统，实现数据的本地汇总。 </p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/industrial_interconnection/default_img2.png" alt="" class="default_img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container platform-trait">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">通信层</p>
          <p class="introduce-item-sub-title">工业物联网需要从云端到终端的整体解决方案，通信层目的是实现本地和云端的数据同步由SCADA进行智能化处理后提取特征数据传回云端工业网关， 分为透传（2G/3G/4G DTU）和非透传（集成多种协议的嵌入式盒子）两种。</p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/industrial_interconnection/default_img3.png" alt="" class="default_img">
          </div>
        </div>
      </div>
      <div class="case-introduce-item-container platform-trait" style="backgroundColor: #f5f6f9;">
        <div class="caseDetails-center-content-container">
          <p class="introduce-item-title">平台层</p>
          <p class="introduce-item-sub-title">平台提供设备连接能力和相应的应用功能，设备连接支持多种连接协议（TCP、ModbusRTU、ModbusTCP、MQTT），触发器支持多种触发条件和微信、 短信、邮件三种报警方式，组态应用个性化定义传感器数值、开关、图表、曲线。</p>
          <div class="introduce-content-container">
            <img src="../../assets/img/caseDetails/industrial_interconnection/default_img4.png" alt="" class="default_img">
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'  

export default {
  name: 'industrial_interconnection',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style lang="scss">
  
</style>